import { UserMenu } from "@/features/Auth/components/UserMenu/UserMenu";
import { useAppNavigation } from "@/features/Navigation/hooks/useAppNavigation";
import { Flex, Spacer, Stack, Text } from "@chakra-ui/react";
import { Breadcrumb, PageContentHeader, PromptStudioLogo } from "@pufflig/prompt-studio-ui";

interface SemanticModelHeaderProps {
  name?: string;
}

export const SemanticModelHeader = ({ name }: SemanticModelHeaderProps) => {
  const { navigateBack, navigateToData } = useAppNavigation();
  return (
    <PageContentHeader>
      <Flex width="26px" mr="spacing-md" onClick={navigateBack} cursor={"pointer"}>
        <PromptStudioLogo />
      </Flex>
      <Breadcrumb parentName="Data" onParentClick={navigateToData}>
        <Flex alignItems="center" gap="spacing-xxs">
          <Text textStyle="label/M/regular">{name || "Semantic Model"}</Text>
        </Flex>
      </Breadcrumb>
      <Spacer />
      <Stack gap="2" direction="row">
        <UserMenu />
      </Stack>
    </PageContentHeader>
  );
};
